var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flex-element',{attrs:{"element-type":_vm.elementType,"class-default-inline":"f-w-1/1"},on:{"dblclick":_vm.onEditHtml}})}
var staticRenderFns = []

export { render, staticRenderFns }